const color = {
    getlist: 'color/getlist',
    add: 'color/add',
    update: 'color/update',
    remove: 'color/remove',
    get: 'color/get',
    getall: 'color/getall',
    clearcache: 'color/clear-cache',
}
export default color
